module.exports = __webpack_public_path__ + "static/media/stratum.ff1e3956.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/legacy-app/stratum.md
// module id = 391
// module chunks = 0